const Genesis = require("../../Genesis.js")
import { post } from "jquery";
import { BlockPageHelper } from '../../Helpers/helpers';
import { ILazyLoadComponentOptions } from './ILazyLoadComponentOptions';


export class LazyLoadComponent {
    private listContainer: JQuery;
    private loadingStatus: JQuery;
    private btnLoadMore: JQuery;
    private filterForm: JQuery;
    private scrollTopBtn: JQuery;
    private httpMethod: string;
    private dateFilterCol: string;
    private requestUrl: string;
    private itemsToLoad: number = 10;
    private currentPage: number = 0;
    private loadedPage: number = 0;
    private totalItems: number = 1;
    private loadedItems: number = 0;

    constructor(options: ILazyLoadComponentOptions) {
        this.listContainer = $(`#${options.ListContainer}`);
        this.loadingStatus = $(`#${options.LoadingStatus}`);
        this.btnLoadMore = $(`#${options.BtnLoadMore}`);
        this.scrollTopBtn = $(`#${options.ScrollTopBtn}`);
        this.filterForm = options.FilterForm != "" ? $(`#${options.FilterForm}`) : $(`#_emptyForm`);
        this.httpMethod = options.HttpMethod;
        this.requestUrl = options.RequestUrl;
        this.dateFilterCol = options.DateFilterCol;

        this.init();
    }

    private init(): void {
        this.btnLoadMore.hide();
        this.loadingStatus.hide();
        this.btnLoadMore.click(() => this.loadItems());
        this.loadItems();

        if (this.scrollTopBtn.length > 0) {
            this.scrollTopBtn.click(function () {
                $('html, body').animate({ scrollTop: 0 }, 800);
            });
        }
       

        $(window).scroll(() => {
            if (this.listContainer.length > 0) {
                if (this.isScrolledToBottom()) {
                    this.loadItems();
                }
            }
            else {
                $(window).off('scroll');
            }
        });
    }

    public loadItems = () => {
        setTimeout(() => {
            this.getItemsFromServer(this.currentPage, this.itemsToLoad);
        }, 1000);
    }

    public async getItemsFromServer(page: number, pageSize: number): Promise<void> {
        if (this.loadedPage <= this.currentPage && this.loadedItems < this.totalItems) {
            this.loadedPage++;
            this.btnLoadMore.hide();
            BlockPageHelper.block();
            var _that = this;
            try {
                if (this.filterForm.length > 0 && this.httpMethod == "POST") {
                    const formData = this.filterForm.serializeArray();
                    var dateFilterCol = this.dateFilterCol.split(',');

                    const objSummaryFilter = formData.reduce((acc, current) => {
                        if (dateFilterCol.includes(current.name) && current.value != "") {
                            const parts = current.value.split('/');
                            acc[current.name] = `${parts[2]}-${parts[1]}-${parts[0]}`;
                        } else {
                            acc[current.name] = current.value;
                        }
                        return acc;
                    }, { StartingRow: (this.currentPage * this.itemsToLoad).toString(), MaxRows: this.itemsToLoad.toString() } as { [key: string]: string });

                    $.post(this.requestUrl, {
                        filterParams: objSummaryFilter
                    }).done(function (responseHtml, textStatus, jqXHR) {
                        var additionalDataJson = jqXHR.getResponseHeader('X-Additional-Data');
                        if (additionalDataJson != null) {
                            var additionalData = JSON.parse(additionalDataJson);
                            _that.totalItems = additionalData.TotalItems;
                            _that.loadedItems = additionalData.ItemIndex;

                            _that.listContainer.append(responseHtml);
                            _that.currentPage++;
                            _that.showLoadingIndicator();
                            if (_that.loadedItems < _that.totalItems) {
                                _that.btnLoadMore.show();
                            }
                        }
                        BlockPageHelper.unblock();
                    }).fail(function (jqXHR, textStatus, errorThrown) {
                        BlockPageHelper.unblock();
                        if (_that.listContainer.length <= 0) {
                            $(window).off('scroll');
                        }
                        console.error(`AJAX request failed: ${textStatus}, ${errorThrown}`);
                    });
                }
                else {
                    $.get(_that.requestUrl, {
                        page: _that.currentPage,
                        pageSize: _that.itemsToLoad
                    }).done(function (responseHtml, textStatus, jqXHR) {
                        var additionalDataJson = jqXHR.getResponseHeader('X-Additional-Data');
                        if (additionalDataJson != null) {
                            var additionalData = JSON.parse(additionalDataJson);
                            _that.totalItems = additionalData.TotalItems;
                            _that.loadedItems = additionalData.ItemIndex;

                            _that.listContainer.append(responseHtml);
                            _that.currentPage++;
                            _that.showLoadingIndicator();
                            if (_that.loadedItems < _that.totalItems) {
                                _that.btnLoadMore.show();
                            }
                        }
                        BlockPageHelper.unblock();
                    }).fail(function (jqXHR, textStatus, errorThrown) {
                        BlockPageHelper.unblock();
                        if (_that.listContainer.length <= 0) {
                            $(window).off('scroll');
                        }
                        console.error(`AJAX request failed: ${textStatus}, ${errorThrown}`);
                    });
                }
            } catch (error) {
                BlockPageHelper.unblock();
                if (this.listContainer.length <= 0) {
                    $(window).off('scroll');
                }
                console.error(`AJAX request failed: ${error}`);
            }
        }
    }

    public showLoadingIndicator(): void {
        this.loadingStatus.show();
        this.loadingStatus.text(`(${this.loadedItems} /  ${this.totalItems})`);
    }

    public isScrolledToBottom(): boolean {
        const scrollTop = $(window).scrollTop();
        const windowHeight = $(window).height();
        const documentHeight = $(document).height();
        if (scrollTop && scrollTop > 1000 && this.scrollTopBtn.length > 0) {
            this.scrollTopBtn.fadeIn();
        } else {
            this.scrollTopBtn.fadeOut();
        }

        if (windowHeight != null && scrollTop && documentHeight) {
            const threshold = 300;
            return scrollTop + windowHeight >= documentHeight - threshold;
        }
        return false;
    }

    public resetPageCount(): void {
        this.listContainer.html("");
        this.itemsToLoad = 10;
        this.currentPage = 0;
        this.loadedPage = 0;
        this.totalItems = 1;
        this.loadedItems = 0;
        this.loadingStatus.text(`(0/0)`);
    }
}